export const APP_NAME = "chapshop";

export const COOKIE_ACCESS_TOKEN_NAME = `${APP_NAME}-access-token`;
export const COOKIE_REFRESH_TOKEN_NAME = `${APP_NAME}-refresh-token`;
export const COOKIE_MANAGER_ACCESS_TOKEN_NAME = `${APP_NAME}-manager-access-token`;
export const COOKIE_MANAGER_REFRESH_TOKEN_NAME = `${APP_NAME}-manager-refresh-token`;
export const COOKIE_ROLE_NAME = `${APP_NAME}-role`;
export const COOKIE_OPTIONS = {
  path: "/",
  secure: import.meta.env.PROD
};

export const BYTES_IN_MB = 1024 * 1024;

export const MAX_IMAGE_FILE_SIZE = 10 * BYTES_IN_MB;
export const MAX_VIDEO_FILE_SIZE = 50 * BYTES_IN_MB;
export const MAX_DOCUMENT_FILE_SIZE = 10 * BYTES_IN_MB;
export const VIDEO_DURATION_LIMIT_IN_SECONDS = 60;

export const IMAGE_FORMATS = [".jpeg", ".jpg", ".png", ".webp"];
export const VIDEO_FORMATS = [".mp4", ".webm"];
export const DOCUMENT_FORMATS = [".pdf", ".doc", ".docx", ".xls", ".xlsx"];

export const MAX_PRODUCT_IMAGES_LIMIT = 20;

export const PAGE_SEARCH_PARAMETER = "page";
export const PRODUCTS_PAGE_SEARCH_PARAMETER = "productsPage";
export const SORT_BY_SEARCH_PARAMETER = "sortBy";
export const SORT_ORDER_SEARCH_PARAMETER = "sortOrder";

export const GET_LIST_REQUEST_DEFAULT_LIMIT = 20;
